import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-pia-speaker-card',
  templateUrl: './pia-speaker-card.component.html',
  styleUrls: ['./pia-speaker-card.component.scss'],
})
export class PiaSpeakerCardComponent implements OnInit {

  constructor() { }

  ngOnInit() {}

}
